// extracted by mini-css-extract-plugin
export var addToCartButton = "_mp-b";
export var arrowButtonContainer = "_mp-9";
export var arrowButtonIcon = "_mp-a";
export var carouselArrowButton = "_mp-6";
export var carouselElementContainer = "_mp-1";
export var left = "_mp-7";
export var productDisplayCarouselContainer = "_mp-0";
export var productTileContainer = "_mp-2";
export var productTileImage = "_mp-4";
export var productTileImageContainer = "_mp-3";
export var productTileTitle = "_mp-5";
export var right = "_mp-8";
export var sliderOverflow = "_mp-c";